<template>
  <div class="page-box">
    <div class="c_page-title">
      <div>账单详情</div>
    </div>
    <div style="margin-bottom: 15px">
      <div v-show="bill_info" class="header-text">
        <div>
          账单编号:{{ bill_info.bill_id }}&nbsp;&nbsp;&nbsp; 账单时间:{{
            bill_info.create_time
          }}&nbsp;&nbsp;&nbsp; 账单状态：
          <span v-if="bill_info.status == 8" style="color: #f56c6c">{{
            getBillStatus(bill_info.status)
          }}</span>
          <span v-else style="color: #67c23a">{{
            getBillStatus(bill_info.status)
          }}</span
          >&nbsp;&nbsp;&nbsp; 涉及订数：{{ bill_info.order_num }}
        </div>
      </div>
    </div>

    <div style="margin-bottom: 15px">
      <div
        style="
          background: #f3f3f3;
          height: 37px;
          line-height: 37px;
          position: relative;
        "
      >
        <span>回货单日期：{{ bill_date.length }}张</span>
        <div
          v-if="bill_info.status == 7 || bill_info.status == 8"
          style="position: absolute; right: 0; top: 0"
        >
          <el-button
            v-show="!normalBill()"
            type="warning"
            size="small"
            @click="splitBill"
            >拆分账单</el-button
          >
        </div>
      </div>
      <div
        v-show="!normalBill()"
        style="height: 50px; border: 1px solid #f3f3f3"
      >
        <el-checkbox-group
          v-if="bill_info.status == 7 || bill_info.status == 8"
          v-model="model.date"
          style="margin-top: 15px"
          @change="dateChange"
        >
          <el-checkbox v-for="date in bill_date" :key="date" :label="date">{{
            date
          }}</el-checkbox>
        </el-checkbox-group>
        <div
          v-for="(date, index) in bill_date"
          v-else
          :key="index"
          style="float: left; width: 100px; height: 30px; line-height: 30px"
        >
          {{ date }}
        </div>
      </div>
    </div>

    <div class="bill-goods">
      <div class="bill-goods-header" style="position: relative">
        <div v-show="supply_info" style="float: left">
          商品列表 &nbsp;&nbsp;&nbsp;{{
            supply_info.supply_name
          }}
          &nbsp;&nbsp;&nbsp; {{ supply_info.pgname }}
        </div>
        <div style="float: left; position: absolute; right: 0">
          <el-input
            v-show="!normalBill()"
            v-model="form.woid"
            style="float: left; width: 150px"
            size="small"
            placeholder="代采订单"
          ></el-input>
          <el-input
            v-model="form.goods_no"
            style="float: left; width: 150px"
            size="small"
            placeholder="商品货号"
          ></el-input>
          <div
            v-show="!normalBill()"
            style="float: left; width: 100px; font-size: 14px"
          >
            回货单日期：
          </div>
          <el-date-picker
            v-show="!normalBill()"
            v-model="form.date"
            style="float: left; width: 150px"
            size="small"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <div style="float: left; margin-top: 3px; padding-right: 10px">
            <el-button
              style="float: left"
              size="small"
              type="primary"
              @click="search()"
              >搜索</el-button
            >
            <el-button
              v-if="
                (bill_info.status == 7 || bill_info.status == 8) &&
                !normalBill()
              "
              style="float: left"
              size="small"
              type="warning"
              @click="splitBill"
              >拆分账单</el-button
            >
            <el-button
              style="float: left"
              size="small"
              type="success"
              @click="output(1)"
              >导出</el-button
            >
            <el-button
              type="text"
              size="small"
              style="float: left"
              :icon="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
              @click="collapse = !collapse"
              >{{ collapse ? "收起" : "展开" }}</el-button
            >
          </div>
        </div>
      </div>
      <div v-show="billGoods" name="el-zoom-in-top">
        <el-table v-show="collapse" :data="billGoods">
          <el-table-column
            prop="finish_owe_time"
            label="回货单日期"
          ></el-table-column>
          <el-table-column prop="woid" label="代采订单">
            <template slot-scope="scope">
              <el-button type="text" @click="redirectOrder(scope.row.woid)">
                {{ scope.row.woid }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="" label="商品图片">
            <template slot-scope="scope">
              <div style="width: 100%; height: 100%">
                <img
                  style="width: 50px; height: 50px"
                  :src="scope.row.goods_img[0]"
                  @click="
                    imgs = scope.row.goods_img;
                    showImg = true;
                  "
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="goods_no" label="货号"></el-table-column>
          <el-table-column prop="co_val" label="颜色"></el-table-column>
          <el-table-column prop="si_val" label="尺码"></el-table-column>
          <el-table-column prop="price" label="代采单价"></el-table-column>
          <el-table-column prop="num" label="实际开单">
            <template slot-scope="scope">
              <span>
                {{ scope.row.num }}/{{
                  parseFloat(
                    Number(scope.row.num) * Number(scope.row.price)
                  ).toFixed(2)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!normalBill()"
            prop="cg_sir_num"
            label="回货金额"
          >
            <template slot-scope="scope">
              {{ caculator(scope.row, 0) }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="!normalBill()"
            prop="finish_owe_time"
            label="入库日期"
          ></el-table-column>
          <el-table-column
            v-if="!normalBill()"
            prop="cg_sir_num"
            label="拆分数量"
            width="150"
          >
            <template slot-scope="scope">
              <div
                v-if="bill_info.status == 7 || bill_info.status == 8"
                style="margin-right: 5px"
              >
                <el-input-number
                  v-model="scope.row.split_num"
                  size="mini"
                  :min="0"
                  :max="Number(scope.row.se_pay_num)"
                  @change="splitNumChange"
                ></el-input-number>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill-goods-header">
          <div style="width: 100%; text-align: right">
            {{ getTotal }}
            <el-button
              v-show="!normalBill()"
              size="mini"
              @click="clearSplitNum"
            >
              数量清零
            </el-button>
            <el-button
              v-show="!normalBill()"
              size="mini"
              type="primary"
              @click="selectAllNum"
              >数量全选</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="bill-goods">
      <div class="bill-goods-header" style="position: relative">
        <div v-show="supply_info" style="float: left">
          商品列表(新) &nbsp;&nbsp;&nbsp;{{
            supply_info.supply_name
          }}
          &nbsp;&nbsp;&nbsp; {{ supply_info.pgname }}
        </div>
        <div style="float: left; position: absolute; right: 0">
          <el-input
            v-show="!normalBill()"
            v-model="form.new_woid"
            style="float: left; width: 150px"
            size="small"
            placeholder="代采订单"
          ></el-input>
          <el-input
            v-model="form.new_goods_no"
            style="float: left; width: 150px"
            size="small"
            placeholder="商品货号"
          ></el-input>
          <div
            v-show="!normalBill()"
            style="float: left; width: 100px; font-size: 14px"
          >
            回货单日期：
          </div>
          <el-date-picker
            v-show="!normalBill()"
            v-model="form.new_date"
            style="float: left; width: 150px"
            size="small"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <div style="float: left; margin-top: 3px">
            <el-button
              style="float: left"
              size="small"
              type="primary"
              @click="search()"
              >搜索</el-button
            >
            <!--                        <el-button style="float: left" size="small" type="success" @click="output(3)">导出</el-button>-->
          </div>
        </div>
      </div>
      <div v-show="plan_order_goods">
        <el-table :data="plan_order_goods.list">
          <el-table-column prop="woid" label="代采订单">
            <template slot-scope="scope">
              <el-button type="text" @click="redirectOrder(scope.row.woid)">
                {{ scope.row.woid }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="" label="代采计划">
            <template slot-scope="scope">
              <p>{{ scope.row.planid }}</p>
              <p>{{ scope.row.wcg_plan_ptype }}</p>
              <p>{{ scope.row.create_time }}</p>
              <p style="color: red">{{ scope.row.goods_type }}</p>
            </template>
          </el-table-column>

          <el-table-column prop="" label="商品图片">
            <template slot-scope="scope">
              <div style="width: 100%; height: 100%">
                <img
                  style="width: 50px; height: 50px"
                  :src="scope.row.main_img"
                  @click="
                    imgs = scope.row.middle_img;
                    showImg = true;
                  "
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="goods_no" label="货号"></el-table-column>
          <el-table-column prop="co_val" label="颜色"></el-table-column>
          <el-table-column prop="si_val" label="尺码"></el-table-column>
          <el-table-column prop="num" label="开单数量"></el-table-column>
          <el-table-column prop="price" label="代采价"></el-table-column>
          <el-table-column prop="total" label="开单价小计"></el-table-column>
          <el-table-column
            prop="activity_fee"
            label="活动服务费小计"
          ></el-table-column>
          <el-table-column prop="" label="佣金小计">
            <template slot-scope="scope">
              <span
                >{{ scope.row.service_fee }}({{
                  scope.row.service_rate
                }}%)</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="dispense_commission_amount"
            label="小店佣金"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="" label="退货服务费小计">
            <template slot-scope="scope">
              <span
                >{{ scope.row.refund_service_fee }}({{
                  scope.row.refund_service_rate
                }}%)</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="price" label="实际支付件/小计">
            <template slot-scope="scope">
              <span>{{ scope.row.num }}/{{ scope.row.true_total }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="bill-goods-header">
          <div style="width: 100%; text-align: right">
            开单
            {{
              plan_order_goods &&
              plan_order_goods.total &&
              plan_order_goods.total_num
            }}件,¥{{
              plan_order_goods &&
              plan_order_goods.total &&
              plan_order_goods.total.price
            }},合计实付金额:{{
              plan_order_goods &&
              plan_order_goods.total &&
              plan_order_goods.total.pay_price
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="page-item">
      <div class="header-text">
        活动服务费商品 共{{ activity_fee_detail.total_kh }}款，{{
          activity_fee_detail.total_num
        }}件，计￥{{ activity_fee_detail.total_amout }}
      </div>
      <el-table :data="activity_fee_detail.list" :span-method="rowSpan" border>
        <el-table-column
          prop="special_start_time"
          label="专场开始时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="woid"
          label="代采订单号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goods_name"
          label="商品名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goods_no"
          label="货号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="co_val"
          label="颜色"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="si_val"
          label="尺码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="plan_price"
          label="拿货单价"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="num"
          label="开单数量"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="activity_time"
          label="活动时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="activity_id"
          label="活动ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="activity_type"
          label="活动类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="activity_name"
          label="活动名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="discount_shop_price"
          label="小计"
          align="center"
        ></el-table-column>
      </el-table>
    </div>

    <div
      v-show="bill_info.status != 7 && bill_info.status != 8"
      class="page-item"
    >
      <div class="header-text" style="position: relative">
        已选抵扣商品 &nbsp;&nbsp;{{ getDedTotal }}
        <div style="position: absolute; right: 0; top: 0">
          <el-button size="small" type="success" @click="output(2)">
            导出
          </el-button>
        </div>
      </div>
      <div style="margin-bottom: 0">
        <el-table border :data="used_ded" tooltip-effect="dark">
          <el-table-column prop="woiid" label="代采订单" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="redirectOrder(scope.row.woid)">
                {{ scope.row.woid }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="referer_type"
            label="来源"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cg_type"
            label="交易方式"
            align="center"
          ></el-table-column>
          <el-table-column prop="goods_img" label="商品图片" align="center">
            <template slot-scope="scope">
              <div style="width: 50px; height: 50px">
                <img
                  v-viewer
                  style="width: 100%; height: 100%"
                  :src="scope.row.goods_img[0]"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="goods_name"
            label="商品名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="goods_no"
            label="商品货号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="goods_kh"
            label="商品款号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="co_val"
            label="颜色"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="si_val"
            label="尺码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="price"
            label="代采单价"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="num"
            label="数量"
            align="center"
          ></el-table-column>
          <el-table-column prop="num" label="小计" align="center">
            <template slot-scope="scope">
              {{
                parseFloat(
                  Number(scope.row.num) * Number(scope.row.price)
                ).toFixed(2)
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="page-item">
      <div class="header-text" style="position: relative">
        活动费抵扣商品 &nbsp;&nbsp;{{ getActiveGoodsTotal }}
        <div style="position: absolute; right: 0; top: 0">
          <el-button size="small" type="success" @click="exportActivityGoods">
            导出
          </el-button>
        </div>
      </div>
      <div style="margin-bottom: 0">
        <el-table :data="activityGoodsInfo" border>
          <el-table-column
            label="活动时间"
            prop="activity_time"
            align="center"
          ></el-table-column>
          <el-table-column
            label="商品名称"
            prop="goods_name"
            align="center"
          ></el-table-column>
          <el-table-column
            label="货号"
            prop="goods_no"
            align="center"
          ></el-table-column>
          <el-table-column
            label="颜色/尺码"
            prop="co_si"
            align="center"
          ></el-table-column>
          <el-table-column
            label="SKU编号"
            prop="sku"
            align="center"
          ></el-table-column>
          <el-table-column
            label="单件优惠额"
            prop="activity_fee"
            align="center"
          ></el-table-column>
          <el-table-column
            label="抵扣数量"
            prop="num"
            align="center"
          ></el-table-column>
          <el-table-column
            label="订单ID"
            prop="order_id"
            align="center"
          ></el-table-column>
          <el-table-column
            label="活动ID"
            prop="activity_id"
            align="center"
          ></el-table-column>
          <el-table-column
            label="活动类型"
            prop="activity_type_text"
            align="center"
          ></el-table-column>
          <el-table-column
            label="活动名称"
            prop="activity_name"
            align="center"
          ></el-table-column>
          <el-table-column
            label="活动费抵扣小计"
            prop="activity_fee_amount"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-item">
      <div class="header-text">让利佣金账单抵扣明细</div>
      <div style="margin-bottom: 0">
        <el-table border :data="rebateData.list" tooltip-effect="dark">
          <el-table-column
            prop="reporting_period"
            label="让利账期"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="bill_no" label="让利账单编号" align="center">
          </el-table-column>
          <el-table-column
            prop="confirm_time"
            label="让利账单确认时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="amount_price"
            label="总结算金额"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="deduction_price"
            label="本单抵扣金额"
            align="center"
          >
          </el-table-column>
        </el-table>
        <div
          style="
            text-align: right;
            height: 40px;
            background: #f3f3f3;
            line-height: 40px;
            padding: 0 40px;
            font-size: 14px;
            color: #ff4040;
          "
        >
          合计让利佣金抵扣金额： ¥{{ rebateData.total }}
        </div>
      </div>
    </div>
    <div class="page-item">
      <div class="header-text">金额明细</div>
      <div style="margin-bottom: 0">
        <el-table border :data="[bill_info]" tooltip-effect="dark">
          <el-table-column
            prop="total_amount"
            label="开单价合计"
            align="center"
          >
            {{ total_amount }}
          </el-table-column>
          <el-table-column
            prop="activity_price"
            label="活动服务费合计"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="service_fee"
            label="平台佣金合计"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="dispense_commission_amount"
            label="小店佣金"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="refund_service_fee"
            label="退货服务费合计"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="real_pay_amount"
            label="实付金额合计"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.true_price }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ded_activity_fee"
            label="活动费用抵扣金额"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="return_profit_fee"
            label="让利佣金抵扣金额"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="reject_pay"
            label="可选抵扣商品"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ Number(caculatorDed().num) - Number(dedData.num) }}/{{
                parseFloat(
                  Number(caculatorDed().amount) - Number(dedData.amount)
                ).toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ded_num"
            label="已选抵扣商品"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              {{ dedData.num }} / {{ dedData.amount }}
              <el-button
                v-show="
                  (bill_info.status == 7 || bill_info.status == 8) &&
                  !normalBill()
                "
                size="mini"
                type="primary"
                @click="showDed = true"
                >选择抵扣
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="need_num"
            label="结算时7天配货率"
            align="center"
          >
            <template slot-scope="scope">
              <p style="margin: 0">
                48小时配货率{{ Number(bill_info.first_target_rate) * 100 }}%
              </p>
              <p style="margin: 0">
                最终配货率{{ Number(bill_info.second_target_rate) * 100 }}%
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="need_num" label="冻结金额（%）" align="center">
            <template slot-scope="scope">
              {{ bill_info.freeze_amount }} ({{
                Number(bill_info.freeze_rate) * 100
              }}%)
            </template>
          </el-table-column>
          <el-table-column
            prop="real_pay_amount"
            label="实际结算金额"
            align="center"
          >
            <template slot-scope="scope">
              {{ bill_info.real_pay_amount }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      v-show="bill_info.status == 7 || bill_info.status == 8"
      class="page-item"
    >
      <div class="header-text">
        收款人信息
        <el-button
          v-if="bill_info.pay_tool == 2"
          type="success"
          size="mini"
          @click="submitBill"
          >提交账单</el-button
        >
      </div>
      <div style="margin-bottom: 0">
        <el-table
          v-if="bill_info.pay_tool != 2"
          :span-method="objectSpanMethod"
          border
          :data="bank_info"
          tooltip-effect="dark"
        >
          <el-table-column prop="payee_name" label="选择" align="center">
            <template slot-scope="scope">
              <el-radio v-model="form.payee_id" :label="scope.row.payee_id">{{
                ""
              }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            prop="payee_name"
            label="收款人名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="payee_bank"
            label="收款银行"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cnap_name"
            label="收款银行支行"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="payee_bank_account"
            label="收款账号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="need_num"
            label="操作"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="submitBill">
                提交账单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div
      v-show="bill_info.status != 7 && bill_info.status != 8"
      class="page-item"
    >
      <div class="header-text">收款人信息</div>
      <div style="margin-bottom: 0">
        <el-table border :data="nullData" tooltip-effect="dark">
          <el-table-column prop="pay_contact" label="收款人名称" align="center">
            <template slot-scope="scope">
              <el-tag
                v-if="bill_info.bank_is_verify == 1"
                type="warning"
                style="size: mini; color: #0e0e0e"
                >已验证</el-tag
              >
              {{ scope.row.pay_contact }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_bank" label="收款银行" align="center">
          </el-table-column>
          <el-table-column prop="cnap_name" label="收款银行支行" align="center">
          </el-table-column>
          <el-table-column prop="pay_account" label="收款账号" align="center">
          </el-table-column>
          <el-table-column
            prop=""
            :label="bill_info.status == 2 ? '付款回执' : '操作'"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="bill_info.status == 0">
                <el-button size="mini" type="success" @click="passBill()">
                  通过
                </el-button>
                <el-button
                  v-show="!normalBill()"
                  size="mini"
                  type="danger"
                  @click="rejectBill()"
                  >驳回</el-button
                >
              </div>
              <div v-if="bill_info.status == 4 && bill_info.pay_tool != 2">
                <el-button
                  size="small"
                  type="primary"
                  @click="update_payee('', bill_info)"
                  >修改付款信息</el-button
                >
              </div>
              <div
                v-if="bill_info.status == 1 && bill_info.pay_tool != 2"
                style="display: flex; flex-direction: column"
              >
                <div style="display: flex; flex-direction: row">
                  <el-upload
                    class="upload-demo"
                    :action="action"
                    multiple
                    :show-file-list="false"
                    :on-success="handleSuccess"
                    :limit="10"
                    with-credentials
                  >
                    <el-button size="small" type="primary">
                      上传回执({{ form.docs.length }})
                    </el-button>
                  </el-upload>
                  <el-button
                    :disabled="form.docs.length > 0 ? false : true"
                    style="margin-left: 20px !important"
                    type="success"
                    size="mini"
                    @click="submitPayDoc()"
                    >完成
                  </el-button>
                  <el-button
                    v-show="!normalBill()"
                    size="mini"
                    type="danger"
                    @click="rejectBill()"
                    >驳回</el-button
                  >
                </div>
                <div
                  v-show="form.docs.length > 0"
                  style="display: flex; flex-direction: row; margin-top: 10px"
                >
                  <div
                    v-for="(item, index) in form.docs"
                    :key="item"
                    style="width: 50px; height: 50px; position: relative"
                  >
                    <div
                      class="el-icon-close"
                      style="
                        color: red;
                        font-size: 18px;
                        margin-right: 10px;
                        position: absolute;
                        width: 15px;
                        height: 15px;
                        right: -5px;
                        top: -5px;
                        cursor: pointer;
                      "
                      @click="delImg(index)"
                    />
                    <img
                      v-viewer
                      style="width: 100%; height: 100%"
                      :src="item"
                    />
                  </div>
                </div>
              </div>
              <div
                v-show="bill_info.pay_tool != 2"
                style="display: flex; flex-direction: row"
              >
                <div
                  v-if="bill_info.status == 2"
                  style="display: flex; flex-direction: row"
                >
                  <img
                    v-for="item in docList"
                    :key="item"
                    style="width: 50px; height: 50px"
                    :src="item"
                    @click="
                      imgs = docList;
                      showImg = true;
                    "
                  />
                </div>

                <div v-if="bill_info.status == 2" style="margin-left: 30px">
                  <div
                    v-show="form.docs.length > 0"
                    style="display: flex; flex-direction: row; margin-top: 10px"
                  >
                    <div
                      v-for="(item, index) in form.docs"
                      :key="item"
                      style="width: 50px; height: 50px; position: relative"
                    >
                      <div
                        class="el-icon-close"
                        style="
                          color: red;
                          font-size: 18px;
                          margin-right: 10px;
                          position: absolute;
                          width: 15px;
                          height: 15px;
                          right: -5px;
                          top: -5px;
                          cursor: pointer;
                        "
                        @click="delImg(index)"
                      />
                      <img
                        v-viewer
                        style="width: 100%; height: 100%"
                        :src="item"
                      />
                    </div>
                  </div>

                  <div style="display: flex; flex-direction: row">
                    <el-upload
                      class="upload-demo"
                      :action="action"
                      multiple
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      accept="image/*"
                      :limit="10"
                      with-credentials
                    >
                      <el-button size="small" type="primary">
                        修改回执({{ form.docs.length }})
                      </el-button>
                    </el-upload>
                    <el-button
                      :disabled="form.docs.length > 0 ? false : true"
                      style="margin-left: 20px !important"
                      type="success"
                      size="mini"
                      @click.stop="editPayDoc"
                      >完成
                    </el-button>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-row v-if="bill_info.status == 4 || bill_info.status == 11">
      <div class="card-title">审核信息</div>
      <div v-if="bill_info.pay_fail_msg.length > 0" class="card-warning">
        {{ bill_info.pay_fail_msg }}
      </div>
      <el-row style="border: 1px solid #ddd; padding: 15px">
        <el-col :span="20" style="height: 200px">
          <el-input
            v-model="textarea"
            type="textarea"
            :rows="9"
            placeholder="暂无备注信息"
          >
          </el-input>
        </el-col>
        <el-col :span="4" style="height: 200px">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              align-items: center;
              height: 100%;
            "
          >
            <div>
              <el-button
                class="btn-operation"
                type="success"
                @click="repay(bill_info)"
                >重新激活</el-button
              >
            </div>
            <div>
              <el-button
                v-show="!normalBill()"
                style="size: medium"
                type="danger"
                @click="rejectBill()"
                >驳回</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </el-row>

    <!--操作日志-->
    <div class="page-item">
      <div class="header-text">操作日志</div>
      <div style="margin-bottom: 0">
        <el-table
          ref="multipleTable"
          border
          :data="log"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column label="操作人" prop="operator" align="center">
          </el-table-column>
          <el-table-column
            prop="action_type"
            label="操作方式"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="操作时间"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="action_result"
            label="操作备注"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <select-ded-goods
      v-if="showDed"
      :used_ded="used_ded"
      :an-arr="anArr"
      :ded_goods="ded_goods"
      @closeDialog="closeDialog"
    ></select-ded-goods>
    <div v-if="UpdatePayeeVisible">
      <update-payee
        :id="$route.params.bill_id"
        :payee="payee"
        :url="url2"
        @onCloseDialog="onCloseDialog"
      ></update-payee>
    </div>
    <preview-image
      v-if="showImg"
      :show="showImg"
      :imgs="imgs"
      @closeBox="closeImg"
    ></preview-image>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-es";
import SelectDedGoods from "./components/SelectDedGoods.vue";
import { supplySettleBillStatus } from "../../tool/const.js";
import { listActivityGoodsByOrder } from "@/controller/purchaseGoods.js";
import UpdatePayee from "../wcgorder/components/UpdatePayee.vue";
import PreviewImage from "../../components/PreviewImage.vue";
import * as vendorProfitConcessionApi from "@/controller/vendorProfitConcession3461.js";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    PreviewImage,
    SelectDedGoods,
    UpdatePayee,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.form.bill_id = to.params.bill_id;
      vm.fetchData();
      vm.getActivityGoodsInfo();
      vm.getRebateData();
    });
  },
  data() {
    return {
      showImg: false,
      imgs: [],
      selected: [],
      bill_date: [],
      docList: [],
      showDed: false,
      billGoods: [],
      plan_order_goods: [],
      supply_info: {},
      bill_info: {},
      bank_info: [],
      ded_goods: [],
      used_ded: [],
      nullData: [],
      log: [],
      total_amount: 0.0,
      anArr: { num: 0, amount: 0.0 },
      dedData: { num: 0, amount: 0.0 },
      form: {
        woid: "",
        goods_no: "",
        bill_id: 0,
        supply_id: 0,
        payee_id: 0,
        ded: [],
        docs: [],
      },
      model: {
        data: [],
        date: [],
        type: 0,
      },
      resData: null,
      loading: false,
      url: "/erp/SupplySettleBill/billGoods",
      origin: 1,
      where: -1,
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      receiptList: [],
      showFileList: false,
      payVisible: false,
      textarea: "",
      submitData: [],
      UpdatePayeeVisible: false,
      url2: "/erp/SupplySettle/updatePayeeLog",
      payee: {},
      // 活动费用明细表格的相关变量
      activity_fee_detail: {
        list: [], // 列表
        total_amout: "0.00", // 活动费用总和
        total_num: 0, // 共计件数
        total_kh: 0, // 共计款数
        rows_span_mark: {
          // 用于标记合并行数的变量
          special: {}, // 专场列需要合并的行数, 以rowIndex为下标
          sku: {}, // sku列需要合并的行数, 以rowIndex为下标
        },
      },
      collapse: false,
      // 活动费商品抵扣
      activityGoodsInfo: [],
      activeGoodsTotal: {
        activity_fee_amount: "",
        goods_kh_num: "",
        goods_num: "",
      },
      rebateData: {
        list: [],
        total: "",
      },
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  computed: {
    filteredForm() {
      const form = cloneDeep(this.form);
      const { bill_id } = this.$route.params;
      for (const key in form) {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      }
      form.bill_id = bill_id;
      return form;
    },
    realAmount() {
      const amount =
        Number(this.total_amount) -
        Number(this.dedData.amount) -
        Number(this.bill_info.freeze_amount) -
        Number(this.bill_info.activity_price);
      return parseFloat(amount).toFixed(2);
    },
    getTotal() {
      const a = {};
      let total_amount = 0;
      let total_num = 0;
      this.billGoods.forEach((row) => {
        a[row.goods_no] = 1;
        const data = this.caculator(row, 1);
        total_num += Number(data.num);
        total_amount += Number(data.total);
      });
      const kh_num = Object.keys(a).length;
      this.total_amount = total_amount = parseFloat(total_amount).toFixed(2);
      this.$set(this, "anArr", {
        num: total_num,
        amount: (total_amount - this.bill_info.activity_price).toFixed(2),
      });
      this.$emit("getTotal", total_amount);
      return `共${kh_num}款，${total_num}件，计¥${total_amount}`;
    },
    getDedTotal() {
      const a = {};
      let total_amount = 0;
      let total_num = 0;
      this.used_ded.forEach((row) => {
        a[row.goods_no] = 1;
        const total = Number(row.price) * Number(row.num);
        total_num += Number(row.num);
        total_amount += Number(total);
      });
      const kh_num = Object.keys(a).length;
      total_amount = parseFloat(total_amount).toFixed(2);
      this.$set(this, "dedData", {
        num: total_num,
        amount: total_amount,
      });
      return `共${kh_num}款，${total_num}件，计¥${total_amount}`;
    },
    getActiveGoodsTotal() {
      const { activity_fee_amount, goods_kh_num, goods_num } =
        this.activeGoodsTotal;
      return `共${goods_kh_num}款，${goods_num}件，计¥${activity_fee_amount}`;
    },
  },

  methods: {
    // 获取活动抵扣商品
    getActivityGoodsInfo() {
      const params = {
        bill_id: this.$route.params.bill_id,
      };
      listActivityGoodsByOrder(params)
        .then((data) => {
          const { goods_list, activity_fee_amount, goods_kh_num, goods_num } =
            data;
          this.activityGoodsInfo = goods_list;
          this.activeGoodsTotal = {
            activity_fee_amount,
            goods_kh_num,
            goods_num,
          };
        })
        .catch(this.$noop);
    },
    closeImg() {
      this.showImg = false;
      this.imgs = [];
    },
    onCloseDialog() {
      this.UpdatePayeeVisible = false;
      this.fetchData();
    },
    repay() {
      this.$confirm("确定激活账单到待付款状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          const args = {
            comments: this.textarea,
            bill_id: this.$route.params.bill_id,
          };

          this.$http.post("/erp/SupplySettleBill/repay", args).then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    update_payee(type, row) {
      this.payee.pay_contact = row.pay_contact;
      this.payee.pay_bank = row.pay_bank;
      this.payee.pay_account = row.pay_account;
      this.payee.cnap = row.cnap;
      this.UpdatePayeeVisible = true;
    },
    fetchData() {
      this.$http
        .post("/erp/SupplySettleBill/billGoods", this.filteredForm)
        .then((res) => {
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          const orderObj = {};
          const { data } = res.data;
          data.list.forEach((item) => {
            orderObj[item.woid] = 1;
          });
          const orderNum = Object.keys(orderObj).length;
          this.billGoods = data.list;
          this.supply_info = data.supply_info;
          this.bill_info = data.bill_info;
          this.bank_info = data.bank_info;
          this.ded_goods = data.ded_goods;
          this.used_ded = data.used_ded;
          this.bill_date = data.bill_date;
          this.plan_order_goods = data.plan_order_goods;
          this.form.supply_id = this.supply_info.supply_id;
          if (this.bill_info.status == 4) {
            this.textarea = this.bill_info.pay_fail_msg;
          }
          this.$set(this.bill_info, "order_num", orderNum);
          this.nullData = [
            {
              pay_account: this.bill_info.pay_account,
              pay_contact: this.bill_info.pay_contact,
              pay_bank: this.bill_info.pay_bank,
              cnap_name: this.bill_info.cnap_name,
            },
          ];
          this.log = data.log;
          this.loading = false;
          this.used_ded.forEach((row) => {
            if (row) {
              this.form.ded.push({
                woiid: row.woiid,
                num: row.num,
                referer_type: row.referer_type_index,
              });
            }
          });

          // 付款回执的处理
          if (
            typeof data.bill_info.pay_doc === "undefined" ||
            !data.bill_info.pay_doc
          ) {
            this.docList = [];
          } else {
            const doc = data.bill_info.origin_pay_doc;
            this.docList = doc;
          }
          // 处理活动费用详情
          this.dealActivityDetail(data.activity_detail);
        });
    },
    caculatorDed() {
      let num = 0;
      let amount = 0.0;
      this.ded_goods.forEach((v) => {
        num += Number(v.num);
        amount += Number(v.num) * Number(v.price);
      });
      return { num, amount };
    },
    caculator(row, bool) {
      const num = Number(row.se_pay_num);
      const total = parseFloat(Number(row.price) * num).toFixed(2);
      if (bool) {
        return { num, total };
      }
      return `${num} / ${total}`;
    },
    closeDialog(e) {
      this.showDed = false;
      this.form.ded = e.ded_list;
      this.dedData = e.caculator_ded;
    },
    objectSpanMethod({ columnIndex }) {
      if (columnIndex == 5) {
        return {
          rowspan: this.bank_info.length,
          colspan: this.bank_info.length,
        };
      }
    },
    submitBill() {
      if (!this.form.bill_id) {
        return this.$message.error("账单编号不能为空");
      }
      if (!this.form.supply_id) {
        return this.$message.error("商家id不能为空");
      }
      this.$http
        .post("/erp/SupplySettleBill/submitBill", this.form)
        .then((res) => {
          if (res.data.code != 200) {
            return this.$message.e(res.data.msg);
          }
          this.fetchData();
        });
    },
    redirectOrder(woid) {
      this.$router.push(`/home/purchaseorderdetail/${woid}`);
    },
    search() {
      this.fetchData();
    },
    output(output_type) {
      this.form.is_excel = 1;
      this.form.output_type = output_type;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.form.output_type = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    exportActivityGoods() {
      const params = {
        is_excel: 1,
        bill_id: this.$route.params.bill_id,
      };

      this.$http
        .post("/erp/WcgOrder/listActivityGoodsByOrder", params)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    passBill() {
      if (!this.form.bill_id || typeof this.form.bill_id === "undefined") {
        return this.$message.error("缺少必要参数账单id");
      }
      this.$confirm("确定审核通过吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/erp/SupplySettle/checkPassBill", {
              bill_id: this.form.bill_id,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              }
              this.$message.success("操作成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("取消");
        });
    },
    rejectBill() {
      if (!this.form.bill_id || typeof this.form.bill_id === "undefined") {
        return this.$message.error("缺少必要参数账单id");
      }
      const args = {
        bill_id: this.form.bill_id,
        comments: this.textarea,
      };

      this.$confirm("确定驳回吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/erp/SupplySettle/cancelSettleBill", args)
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              this.$message.success("操作成功");
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.info("取消");
        });
    },
    getBillStatus(status) {
      let text = "";
      supplySettleBillStatus.forEach((row) => {
        if (row.value == status) {
          text = row.label;
        }
      });
      return text;
    },
    handleSuccess(response) {
      console.log(response);
      if (response.code != 200) {
        return this.$message.error("上传图片失败1");
      }
      const files = response.data.origin_files;
      if (
        typeof files !== "object" &&
        Object.prototype.toString.call(files) !== "[object Array]"
      ) {
        return this.$message.error("上传图片失败");
      }
      if (files.length < 1) {
        return this.$message.error("上传图片失败!");
      }
      this.form.docs = this.form.docs.concat(files);
    },
    delImg(index) {
      this.form.docs.splice(index, 1);
    },
    submitPayDoc() {
      if (this.form.docs.length < 1) {
        return this.$message.error("请上传回执");
      }
      const params = {
        doc: this.form.docs,
        bill_id: this.form.bill_id,
      };
      this.$http.post("/erp/SupplySettle/uploadPayDoc", params).then((res) => {
        if (res.data.code != 200) {
          return this.$message.error(res.data.msg);
        }
        this.$message.success("账单回执提交成功");
        this.fetchData();
      });
    },
    editPayDoc() {
      if (this.form.docs.length < 1) {
        return this.$message.error("请上传回执");
      }
      const params = {
        doc: this.form.docs,
        bill_id: this.form.bill_id,
      };
      this.$http.post("/erp/SupplySettle/editPayDoc", params).then((res) => {
        if (res.data.code != 200) {
          return this.$message.error(res.data.msg);
        }
        this.form.docs = [];
        this.$message.success("修改账单回执成功");
        this.fetchData();
      });
    },
    clearSplitNum() {
      this.billGoods.forEach((val, index) => {
        this.billGoods[index].split_num = 0;
      });
      this.model.type = 2;
    },
    splitNumChange() {
      this.model.type = 2;
      this.model.date = [];
    },
    dateChange(val) {
      this.model.type = 1;
      this.model.date = val;
      this.model.data = [];
    },
    selectAllNum() {
      this.billGoods.forEach((val, index) => {
        this.billGoods[index].split_num = val.se_pay_num;
      });
      this.model.type = 2;
    },
    splitBill() {
      this.model.bill_id = this.bill_info.bill_id;
      if (this.model.type != 1 && this.model.type != 2) {
        return this.$message.error("请选择拆分项");
      }
      if (this.model.type == 2) {
        this.model.date = [];
        this.model.data = [];
        this.billGoods.forEach((val) => {
          if (val.split_num > 0) {
            this.model.data.push(val);
          }
        });
      }
      if (this.model.type == 1) {
        this.model.data = [];
      }
      this.$confirm("确定需要拆分账单？", "提示", {
        center: true,
      })
        .then(() => {
          this.$http
            .post("/erp/SupplySettleBill/splitBill", this.model)
            .then((res) => {
              if (res.data.code != 200) {
                return this.$message.error(res.data.msg);
              }
              this.$message.success("操作成功");
              this.$router.push("/home/OkSupplyBill");
            });
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },

    // 常规拿货单
    normalBill() {
      return this.bill_info.bill_type == 2;
    },
    // 处理活动费用详情
    dealActivityDetail(data) {
      if (data.length == 0) return;
      const list = [];
      let common_index = 0; // 计算循环次数
      let total_amout = 0; // 总活动费用
      const goods_nos = []; // 用于计算款号
      data.forEach((special) => {
        // console.log(special);
        special.detail.forEach((v, index) => {
          // sku
          const _temp_index = common_index;
          v.sku.forEach((sku_row, sku_index) => {
            // 活动
            this.activity_fee_detail.rows_span_mark.sku[common_index] =
              sku_row.detail.length;
            sku_row.detail.forEach((activity) => {
              activity.special_index = index;
              activity.sku_index = sku_index;
              activity.special_start_time = v.special_start_time; // 专场开始时间
              activity.num = sku_row.num; // 开单数量
              activity.co_val = sku_row.co_val;
              activity.si_val = sku_row.si_val;
              activity.goods_name = sku_row.goods_name;
              activity.goods_no = sku_row.goods_no;
              activity.market_price = sku_row.market_price;
              activity.plan_price = sku_row.plan_price;
              activity.woid = sku_row.woid;
              list.push(activity);
              common_index++;
            });
            this.activity_fee_detail.total_num += sku_row.num;
            if (!goods_nos.includes(sku_row.goods_no))
              goods_nos.push(sku_row.goods_no);
          });
          this.activity_fee_detail.rows_span_mark.special[_temp_index] =
            common_index - _temp_index;
        });
        total_amout += Number(special.activity_fee);
      });
      this.activity_fee_detail.total_amout = parseFloat(total_amout).toFixed(2);
      this.activity_fee_detail.total_kh = goods_nos.length;
      this.activity_fee_detail.list = list;
    },

    // 活动明细表的处理
    rowSpan({ rowIndex, columnIndex }) {
      // sku和数量也要合并
      if ([1, 2, 3, 4, 5, 6, 7].includes(columnIndex)) {
        if (
          typeof this.activity_fee_detail.rows_span_mark.sku[rowIndex] !==
          "undefined"
        ) {
          return [this.activity_fee_detail.rows_span_mark.sku[rowIndex], 1];
        }
        // 显示行 不显示列
        return [1, 0];
      }

      // 第一列专场时间肯定要合并的,
      if (columnIndex == 0) {
        if (
          typeof this.activity_fee_detail.rows_span_mark.special[rowIndex] !==
          "undefined"
        ) {
          return [this.activity_fee_detail.rows_span_mark.special[rowIndex], 1];
        }
        return [1, 0];
      }
      return [1, 1];
    },
    // 获取让利数据
    getRebateData() {
      vendorProfitConcessionApi
        .listSsbReturnProfitBillDetail({
          bill_id: this.$route.params.bill_id,
        })
        .then((res) => {
          this.rebateData = res;
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.header-text {
  background: #f3f3f3;
  height: 40px;
  line-height: 40px;
}

.page-item {
  margin-top: 20px;
}

.page-box {
  padding: 0 20px;
}

.bill-goods-header {
  display: flex;
  flex-direction: row;
  height: 40px;
  line-height: 40px;
  background-color: rgb(243, 243, 243);
}

.el-tag--warning {
  background-color: rgb(255, 218, 114);
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.card-warning {
  background: #e8aae1;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/OkSupplyBillDetail.vue